import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change, reset } from 'redux-form'
import Calendar from 'react-calendar';
import Moment from 'react-moment'
import { 
  Input,
  Icon,
  Button } from  'semantic-ui-react'
import {
  Collapse } from '@material-ui/core';
import { 
  getCompanies 
} from 'ducks/options'
  

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { 
  SearchCont,
  DateCont } from './styled'

const SearchBLReportList = (props) => {
  const {
    valueForm,
    formSearchName,
    companies,
    companyFilter,
    getCompanies,
    change,
    //props
    fetchAPI,
  } = props

  const [visibleSelectDate,setVisibleSelectDate] = React.useState(false)
  const [visibleAS,setVisibleAS] = React.useState(false)
  const [date,setDate] = React.useState([null,null])
  const [companyOptions,setCompanyOptions] = React.useState([])
  const [companyPlantOptions,setCompanyPlantOptions] = React.useState([])
  const [showCompanyPlantOptions,setShowCompanyPlantOptions] = React.useState(false)

  React.useEffect(() => {
    change(formSearchName,'dateStart',date[0]?new Date(date[0]).toJSON():valueForm.dateStart)
    change(formSearchName,'dateEnd',date[1]?new Date(date[1]).toJSON():valueForm.dateEnd)
  },[date])

  React.useEffect(()=>{
    getCompanies()
  },[])

  function onAdvanceSearchClick(){
    fetchAPI(!visibleAS)
  }

  React.useEffect(()=>{
    if(companies.data){
      let sortCompany = companies.data.sort((a, b) => a.text?a.text.localeCompare(b.text):-1)
      if(companyFilter.length){
        sortCompany = sortCompany.filter((x)=>companyFilter.findIndex((xx)=>xx.companyCode == x.value)>=0)
      }
      setCompanyOptions(sortCompany)
    }
  },[companyFilter,companies])

  // React.useEffect(()=>{
  //   if(valueForm?.companyCode){
  //     let CompanyPlantOptions = []
  //     valueForm?.companyCode
  //     let findCompany = companyFilter.find((x)=>{x.companyCode == valueForm.companyCode})
  //     if(findCompany?.companyPlant?.length){
  //       setCompanyPlantOptions(findCompany.companyPlant.map((x)=>({
  //         key:x,
  //         value:x,
  //         text:x
  //       })))
  //       setShowCompanyPlantOptions(true)
  //     }
  //   }
  // },[valueForm?.companyCode])


  return (
    <SearchCont>
      <React.Fragment>
        <div style={{display:'flex',alignItems:'center'}}>
          <div style={{width:'15rem'}}>
            <Field
              name='reportType'
              label='Report'
              placeHolder='Select Report'
              allowAdditions={false}
              options={[
                { value: 1, text: 'Billing' },
                { value: 2, text: 'Goods Service Receipt' },
              ]}
              type={type.select}
              component={FieldInput}
            />
          </div>
          <DateCont>
            <Moment format="DD MMM YYYY">{date[0]||Date.now()}</Moment>
            {`  -  `}
            <Moment format="DD MMM YYYY">{date[1]||Date.now()}</Moment>
          </DateCont>
          <Icon name='calendar alternate outline' circular inverted link onClick={()=>setVisibleSelectDate(!visibleSelectDate)}/>
          <Field
            name="companyCode"
            label="Company"
            allowAdditions={false}
            loading={companies.loading}
            options={companyOptions}
            type={type.multiSelect}
            component={FieldInput}
          />
          {/* {showCompanyPlantOptions?
          <Field
            name="companyPlant"
            label="CompanyPlant"
            allowAdditions={false}
            loading={companies.loading}
            options={companyPlantOptions}
            type={type.multiSelect}
            component={FieldInput}
          />:null} */}
          <Button onClick={()=>onAdvanceSearchClick()}>Search</Button>
          <Icon name='settings' circular inverted link onClick={()=>setVisibleAS(!visibleAS)}/>
        </div>
        <Collapse in={visibleSelectDate} timeout="auto" unmountOnExit>
          <div style={{marginTop:'0.5rem'}}>
            <Calendar
              onChange={(date)=>{
                setDate(date)
                setVisibleSelectDate(false)
              }}
              value={date}
              selectRange={true}
            />
          </div>
        </Collapse>
        <Collapse in={visibleAS} timeout="auto" unmountOnExit>
          <Field name="key" onSearchClick={()=>onAdvanceSearchClick()} component={renderInputSearch} onEnter={()=>onAdvanceSearchClick()}/>         
        </Collapse>
      </React.Fragment>
    </SearchCont>
  )

}

const renderInputSearch = props => {
  const {input,onSearchClick,placeholder} = props
  return (
    <Input 
    {...input}
    onKeyDown={(e)=>{
      if (e.key === 'Enter') {
        props.onEnter()
      }
    }}
    className='searchInput' 
    icon={<Icon type='button' name='search' inverted circular link onClick={onSearchClick}/>} 
    placeholder={'Doc. No. , PO No. , GR No,  Vendor Name'} 
    style={{marginBottom:'1rem', fontSize:'0.9rem', width:'29.2rem'}}
    />
  )
}

const mapStateToProps = (state,props) => {
  return ({
    valueForm: getFormValues(props.formSearchName)(state),
    companies: state.options.companies,
    companyFilter: state.report.companyFilter||[],
  })
}

const mapDispatchToProps = {
  change,
  getCompanies
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchBLReportList)
